import type { InstallationQualification } from '../types';

function escapeCSVValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  let str = String(value);
  if (/^[=+\-@\t\r]/.test(str)) {
    str = `'${str}`;
  }
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function formatDateTime(value: string | null): string {
  if (!value) return '';
  return new Date(value).toLocaleString('en-CA');
}

function getOrganisationDisplayName(item: InstallationQualification): string {
  if (item.accountName && item.accountNumber) return `${item.accountNumber} ${item.accountName}`;
  return item.accountName || item.organisationName || '';
}

const EXPORT_COLUMNS = [
  { label: 'Report Number', getValue: (item: InstallationQualification) => item.reportNumber },
  { label: 'Organisation', getValue: (item: InstallationQualification) => getOrganisationDisplayName(item) },
  { label: 'Sensor', getValue: (item: InstallationQualification) => item.sensorName || '' },
  { label: 'Transmitter', getValue: (item: InstallationQualification) => item.transmitterName || item.transmitterDevId || '' },
  { label: 'Responsible', getValue: (item: InstallationQualification) => item.responsibleName || '' },
  { label: 'Created At', getValue: (item: InstallationQualification) => formatDateTime(item.reportedAt) },
  { label: 'Verified By', getValue: (item: InstallationQualification) => item.verifiedByName || '' },
  { label: 'Verified At', getValue: (item: InstallationQualification) => formatDateTime(item.verifiedAt) },
  { label: 'State', getValue: (item: InstallationQualification) => item.state },
  { label: 'Type', getValue: (item: InstallationQualification) => item.qualificationType },
  { label: 'Quote Number', getValue: (item: InstallationQualification) => item.quoteNumber || '' },
  { label: 'Ticket Number', getValue: (item: InstallationQualification) => item.ticketNumber || '' },
];

export function exportInstallationQualificationsToCSV(
  items: InstallationQualification[],
  filename = 'installation-qualifications',
): void {
  const header = EXPORT_COLUMNS.map((column) => escapeCSVValue(column.label)).join(',');
  const rows = items.map((item) =>
    EXPORT_COLUMNS.map((column) => escapeCSVValue(column.getValue(item))).join(','),
  );
  const csv = [header, ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function copyInstallationQualificationsToClipboard(
  items: InstallationQualification[],
): Promise<void> {
  const header = EXPORT_COLUMNS.map((column) => column.label).join('\t');
  const rows = items.map((item) =>
    EXPORT_COLUMNS.map((column) => String(column.getValue(item) ?? '')).join('\t'),
  );
  await navigator.clipboard.writeText([header, ...rows].join('\n'));
}
